import { useQueryWithUserId } from '@northladder/services';

import { USER_REGISTRATION_API } from '../userRegistrationAPIClient';
import { IBuyerAssetGroupsPayload } from '../types';

// This is to track the buyer asset groups from the backend.
const BUYER_ASSET_GROUPS_KEY = 'buyer-asset-groups-key';

// Hook to fetch buyer asset groups given category and brand id(s). Supports multiple brands.
export const useBuyerAssetGroupsQuery = (params: IBuyerAssetGroupsPayload) => {
  const { categoryId, brandIds } = params;
  const { data, isError, error, isEnabled, isPending, refetch } =
    useQueryWithUserId({
      // eslint-disable-next-line @tanstack/query/exhaustive-deps
      queryKey: [BUYER_ASSET_GROUPS_KEY, categoryId, brandIds],
      networkMode: 'always',
      enabled: !!categoryId && (brandIds?.length ?? 0) > 0,
      queryFn: () =>
        USER_REGISTRATION_API.fetchBuyerAssetGroups({
          brandIds: brandIds ?? [],
          categoryId,
        }),
    });

  return {
    data,
    error,
    isEnabled,
    isError,
    isPending,
    refetch,
  };
};
